module.exports = __webpack_public_path__ + "img/icon-7.987abe12.png";